if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.querySelectorAll('.color-swatch:not([color_swatch_product])').forEach((s) => {
        s.addEventListener('click', this.onSwatchClick.bind(this));
        s.addEventListener('keydown', this.onSwatchKeydown.bind(this));
      });

      const productGroupSwatches = this.querySelectorAll('[product_group_swatch] [color_swatch_product]');
      productGroupSwatches.forEach((swatch) => {
        swatch.addEventListener('click', this.onProductGroupSwatchHover.bind(this));
        swatch.addEventListener('keydown', this.onSwatchKeydown.bind(this));
      });
    }

    onSwatchKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      if (event.currentTarget.hasAttribute('color_swatch_product')) {
        this.onProductGroupSwatchHover(event);
      } else {
        this.onSwatchClick(event);
      }
    }

    onSwatchClick(event) {
      const swatch = event.currentTarget.closest('.color-swatch') || event.currentTarget;
      const productImage = this.querySelector(`[data-product-image="${this.dataset.productId}"]`);
      const swatchImageElement = swatch.querySelector('.data-variant-image');
      const newImageUrl = swatchImageElement ? swatchImageElement.getAttribute('src') : null;
      const newSrcset = swatchImageElement ? swatchImageElement.getAttribute('srcset') : null;

      this.querySelectorAll('.color-swatch').forEach((s) => {
        s.classList.remove('selected');
        s.setAttribute('aria-pressed', 'false');
      });
      swatch.classList.add('selected');
      swatch.setAttribute('aria-pressed', 'true');

      if (productImage && swatchImageElement) {
        productImage.src = newImageUrl;
        productImage.srcset = newSrcset;
      }
    }

    onProductGroupSwatchHover(event) {
      const hoveredSpan = event.currentTarget.closest('[color_swatch_product]') || event.currentTarget;
      if (!hoveredSpan) return;

      this.querySelectorAll('[color_swatch_product]').forEach((s) => {
        s.classList.remove('selected');
        s.setAttribute('aria-pressed', 'false');
      });
      hoveredSpan.classList.add('selected');
      hoveredSpan.setAttribute('aria-pressed', 'true');

      const productUrl = hoveredSpan.getAttribute('data-product-url');
      const productId = hoveredSpan.getAttribute('data-product-id');
      const productImageUrl = hoveredSpan.getAttribute('data-product-image');
      const productPrice = hoveredSpan.getAttribute('data-product-price');
      const cardMediaLink = this.querySelector('a.card-media');
      const productImage = this.querySelector('.card-media-child img');
      const priceElement = this.querySelector('.price__regular .price-item');
      const ModelOpner = this.querySelector('modal-opener');
      const QuickSubmitButton = this.querySelector('.quick-add__submit');
      const productAvailable = hoveredSpan.getAttribute('data-product-available');
      let ProductBadge = this.querySelector('.card__badge span');
      
      if (productUrl && cardMediaLink) {
        cardMediaLink.href = productUrl;
        QuickSubmitButton.setAttribute('data-product-url', productUrl);
      }

      if (productAvailable === 'true' && ProductBadge) {
        if (ProductBadge.textContent === 'Sold out') {
          ProductBadge.style.display = 'none';
        }
      } else if (productAvailable === 'false') {
        if (!ProductBadge) {
          const badgeContainer = this.querySelector('.card__badge');
          if (badgeContainer) {
            ProductBadge = document.createElement('span');
            ProductBadge.className = 'badge badge--bottom-left color-scheme-3';
            ProductBadge.textContent = 'Sold out';
            badgeContainer.appendChild(ProductBadge);
          }
        } else {
          ProductBadge.textContent = 'Sold out';
          ProductBadge.style.display = 'inline-block';
        }
      }

      if (ModelOpner) {
        ModelOpner.setAttribute('data-modal', `#QuickAdd-${productId}`);
      }
      
      if (productImageUrl && productImage) {
        productImage.src = productImageUrl;
        productImage.srcset = '';
      }
      
      if (productPrice && priceElement) {
        priceElement.textContent = productPrice;
      }
    }
  }

  customElements.define('product-card', ProductCard);
}